export const state = () => ({
  project: {
    transcriptions: [],
  }
})

export const getters = {
  project(state) {
    return state.project
  },

  transcriptions(state) {
    return state.project.transcriptions
  }
}

export const mutations = {
  SET_PROJECT(state, project) {
    state.project = project
  },

  SET_TRANSCRIPTIONS(state, transcriptions) {
    state.project.transcriptions = transcriptions
  },

  UPDATE_TRANSCRIPTION(state, payload) {
    state.project.transcriptions.splice(payload.index, 1, payload.transcription)
  },
}
